export enum ServiceModelsMutations {
    SET_VIEW = 'SET_VIEW',
}
